import { IGalleryConfig } from '@bridebook/web/app-basic/components/supplier/sections/gallery/gallery';
import { Box, ButtonV2 } from '@bridebook/ui';
import componentStyles from './carousel-cta-cover.style';

interface CarouselCtaCoverProps {
  header: string;
  desc: string;
  button: string;
  size?: IGalleryConfig['ctaSize'];
}

export const CarouselCtaCover = ({ header, desc, button, size }: CarouselCtaCoverProps) => {
  const styles = componentStyles(size);

  return (
    <Box style={styles.wrapper}>
      <Box style={styles.header}>{header}</Box>
      <Box style={styles.desc}>{desc}</Box>
      <Box>
        <ButtonV2 size={size}>
          <Box style={styles.button}>{button}</Box>
        </ButtonV2>
      </Box>
    </Box>
  );
};
